import React, { useEffect } from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { EmotionalHook } from './components/EmotionalHook';
import { ComparisonTable } from './components/ComparisonTable';
import { MethodSection } from './components/MethodSection';
import { PackDetails } from './components/PackDetails';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-warm-white font-lato" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <EmotionalHook data-id="element-3" />
      <ComparisonTable data-id="element-4" />
      <MethodSection data-id="element-5" />
      <PackDetails data-id="element-6" />
      <Guarantee data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FAQ data-id="element-9" />
      <ClosingSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}